<div [ngClass]="{'header-v2-customized' : isCustomized}" class="header-v2">
    <div class="visible-xs" style="margin-top: 1rem;" *ngIf="mainService.sessionService.isCustomized">
        <img style="max-width: 200px; max-height: 75px;" src="{{ mainService.loginService.getPathLogo() }}"
            alt="Logotipo">
    </div>

    <div class="icon-and-balance">
        <div class="icone-menu">
            <div class="hidden-xs" (click)="mainService.loginService.goHome()" id="goHome-logo-interno">
                <img *ngIf="mainService.sessionService.isCustomized" style="max-width: 200px; max-height: 75px;"
                    src="{{ mainService.loginService.getPathLogo() }}" alt="Logotipo">
                <img *ngIf="!mainService.sessionService.isCustomized" src="../../assets/img/icones_menu.svg"
                    alt="Icone menu">
            </div>
            <div class="visible-xs" (click)="toggleMenuMobile()" id="goHome-logo-interno">
                <img src="../../assets/img/icones_menu.svg" alt="Icone menu">
            </div>
            <div class="informacao-cartao" [ngClass]="{'informacao-cartao-customized' : isCustomized}">
                <strong>Olá, Premiado(a)!</strong>
                <br> {{ mainService.cartaoService.cartao.numero | cartao }} <br />
                <strong>SALDO:</strong> <span id="saldoHeaderDesktop" style="font-size: 1.2em;">{{
                    mainService?.loginService?.saldoService?.saldo?.saldoPontos }}</span> pontos
                <span *ngIf="mainService?.loginService?.saldoService?.saldo?.saldoPontos">
                    ({{ applyConversion() | currencyformat }})
                </span>
            </div>
        </div>

        <div class="navbar-v2">
            <div *ngIf="!mainService.loginService.isVoucher()" (click)="mainService.loginService.changeRoute('/cartao')"
                class="hidden-xs" id="btn-meu-cadastro">
                <img *ngIf="!isCustomized" src="../../assets/img/icons/bt_cadastro.svg" alt="Botão Cadastro">
                <img *ngIf="isCustomized" src="../../assets/img/icons/bt_cadastro_roxo.svg" alt="Botão Cadastro">
            </div>

            <div *ngIf="!mainService.loginService.isVoucher()" class="hidden-xs"
                (click)="mainService.loginService.changeRoute('/perguntas-frequentes')" id="btn-perguntas-frequentes">
                <img *ngIf="!isCustomized" src="../../assets/img/icons/bt_duvidas.svg" alt="Botão Dúvidas">
                <img *ngIf="isCustomized" src="../../assets/img/icons/bt_duvidas_roxo.svg" alt="Botão Dúvidas">
            </div>

            <div *ngIf="!mainService.loginService.isVoucher()" (click)="mainService.loginService.changeRoute('/sac')"
                id="btn-sac" class="hidden-xs">
                <img *ngIf="!isCustomized" src="../../assets/img/icons/bt_sac.svg" alt="Botão SAC">
                <img *ngIf="isCustomized" src="../../assets/img/icons/bt_sac_roxo.svg" alt="Botão SAC">
                <span class="badge"
                    *ngIf="mainService.loginService.ciService.quantidadeMensagensNaoLidas > 0">{{mainService.loginService.ciService.quantidadeMensagensNaoLidas}}</span>
            </div>

            <div (click)="mainService.loginService.doLogout()" id="logout">
                <img *ngIf="!isCustomized" src="../../assets/img/icons/bt_sair.svg" alt="Botão Sair">
                <img *ngIf="isCustomized" src="../../assets/img/icons/bt_sair_roxo.svg" alt="Botão Sair">
            </div>
        </div>
    </div>

</div>


<ul class="header-menu-list-v2 hidden-xs">
    <li (click)="mainService.loginService.changeRoute('/saldo'); hideMenuMobile()">Extrato</li>
    <li *ngIf="mainService.loginService.permissionService.hasPermission('funcionalidade:pagamento') 
            && mainService.cartaoService.isCompletos()"
        (click)="mainService.loginService.changeRoute('/pagamentos'); hideMenuMobile()">
        Pagamentos</li>
    <li *ngIf="(mainService.loginService.permissionService.hasPermission('funcionalidade:ted')
        || mainService.loginService.permissionService.hasPermission('funcionalidade:ted_cartao')
        || mainService.cartaoService.cartao.produto.bandeira) && mainService.cartaoService.isCompletos()"
        (click)="mainService.loginService.changeRoute('/transferencias'); hideMenuMobile()">Paycash</li>
    <li *ngIf="mainService.loginService.permissionService.hasPermission('funcionalidade:vale_presente') 
            && mainService.cartaoService.isCompletos()"
        (click)="mainService.loginService.changeRoute('/valepresente'); hideMenuMobile()">
        Vale-presente</li>
    <!-- <li *ngIf="mainService.loginService.permissionService.hasPermission('funcionalidade:recarga_celular') 
            && mainService.cartaoService.isCompletos()"
        (click)="mainService.loginService.changeRoute('/recarga/celular'); hideMenuMobile()">Recarga de celular</li> -->
        <!-- <li *ngIf="mainService.sessionService.getUserId() === 7 
            && mainService.cartaoService.isCompletos()"
        (click)="mainService.loginService.changeRoute('/recarga/celular'); hideMenuMobile()">Recarga de celular</li> -->
    <li *ngIf="mainService.loginService.permissionService.hasPermission('funcionalidade:loja') 
            && mainService.cartaoService.isCompletos()"
        (click)="mainService.loginService.changeRoute('/loja'); hideMenuMobile()">Loja
    </li>
</ul>


// WEBPACK FOOTER //
// ./src/app/app-header/app-header.component.html